import React, { useEffect, useState } from "react";
import { EditVehicleWrapper } from "../style/EditVehicle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import { toast } from "react-toastify";
import { APIError } from "../../../core/utils";
import CopyToClipboard from "react-copy-to-clipboard";
import copy from "../../../assets/Images/icons/faLink.svg";


const EditBlockedChatMessages = () => {

  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);

  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState({});
  const { textId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const storedLanguages = JSON.parse(localStorage.getItem("languages") || "[]");
    const storedCountries = JSON.parse(localStorage.getItem("countries") || "[]");

    setLanguages(storedLanguages);
    setCountries(storedCountries);

    // Initialize name fields only after setting languages
    const initialNames = {};
    storedLanguages.forEach((lang) => {
      initialNames[lang.code] = "";
    });
    setName(initialNames);
  }, []);

  useEffect(() => {
    if (textId) {
      fetchSuggestionText();
    }
  }, [textId]);

  const fetchSuggestionText = () => {
    API.get(`${APP_URLS.SHOW_SUGGESTION_TEXT}/${textId}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success) {
          setName((prev) => ({ ...prev, ...resp.data.suggestionText.name }));
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch((err) => {
        toast.error(APIError(err), { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const handleTitleChange = (val, code) => {
    setName((prev) => ({ ...prev, [code]: val }));
  };

  const getSearchParamsString = () => {
    const params = [
      searchParams.get("name") && `name=${searchParams.get("name")}`,
      searchParams.get("per_page") &&
      `per_page=${searchParams.get("per_page")}`,
      searchParams.get("page") && `page=${searchParams.get("page")}`,
    ]
      .filter(Boolean)
      .join("&");

    return params;
  };

  const submitForm = () => {
    if (!name["en"] && !name["fr"]) {
      toast.error("Message in English and French is mandatory", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!name["en"]) {
      toast.error("Please provide message in English", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!name["fr"]) {
      toast.error("Please provide message in French", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!loading) {
      setLoading(true);
      API.post(`${APP_URLS.UPDATE_SUGGESTION_TEXT}/${textId}?_method=patch`, {
        name,
      })
        .then((res) => {
          setLoading(false);
          const resp = res.data;
          if (resp.success) {
            toast.success("Blocked chat message updated successfully.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            navigate(
              `/translation/blocked-chat-message?${getSearchParamsString()}`
            );
          } else {
            toast.error(resp.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(APIError(err), {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  return (
    <EditVehicleWrapper>
      <div className="mt-2">
        <div
          className="backContainer ms-4"
          onClick={() =>
            navigate(
              `/translation/blocked-chat-message?${getSearchParamsString()}`
            )
          }
        >
          <span className="backButton">x</span>
          <span className="px-3 backButton">|</span>
          <span className="backButton">Cancel</span>
        </div>
      </div>

      <div className="headerContainer">
        <h1>EDIT BLOCKED CHAT MESSAGES</h1>
      </div>

      <div className="d-flex justify-content-between save-btn mt-3">
        <p className="fieldLabel">Title</p>
        <button
          className={`add-button ${loading ? "disabled" : ""}`}
          onClick={submitForm}
          disabled={loading}
        >
          Save
        </button>
      </div>

      <div className="row input-fileds">
        {languages.map((language) => {
          const code = language.code;
          const flag = countries.find(
            (c) => c.id === language.country_id
          )?.flag_thumbnail;

          return (
            <div className="col-md-4" key={language.id}>
              <div className="col-md-12 mt-3">
                <label htmlFor={`title-${code}`} className="form-label">
                  <span className="countryIcon px-2">
                    <img
                      src={flag}
                      alt=""
                      className="countryflag"
                      title={language.name}
                    />
                  </span>
                  <span className="langName">{code}</span>
                </label>
                <textarea
                  id={`title-${code}`}
                  name={`title-${code}`}
                  className="form-control departmentFields"
                  rows={5}
                  value={name[code] || ""}
                  onChange={(e) => handleTitleChange(e.target.value, code)}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="suggested-labels">
        <p className="fieldLabel">Suggested labels</p>
        <ul>
          <li>
            <span>{"{{username}}"}</span>
            <CopyToClipboard text={"{{username}}"} onCopy={() => toast("Text Copied")}>
              <img className="ms-2" src={copy} alt="" />
            </CopyToClipboard>
          </li>
          <li>
            <span>{"{{ad}}"}</span>
            <CopyToClipboard text={"{{ad}}"} onCopy={() => toast("Text Copied")}>
              <img className="ms-2" src={copy} alt="" />
            </CopyToClipboard>
          </li>
        </ul>
      </div>
    </EditVehicleWrapper>
  );
};

export default EditBlockedChatMessages;
